import { Component, Container } from "../..";
import { Panel } from "../panel/Panel";
import { PanelProps } from "../panel/PanelProps";
import { SearchPanel } from "./SearchPanel";

export class FieldsPanel extends Panel {
    private searchPanel: SearchPanel;

    constructor(searchPanel: SearchPanel, props?: Partial<PanelProps>) {
        super({
            margin: 0,
            padding: 0,
            paddingLeft: 8,
            paddingRight: 8,
            fillRow: true,
            rowBreakDefault: false,
            ...props
        });
        this.searchPanel = searchPanel;
        this._designer = this.searchPanel._designer;
    }

    protected override doAfterChildAdded(child: Component) {
        super.doAfterChildAdded(child);
        if (!(child instanceof Container) && child.field != null) {
            child.searchOnly = true;
            child.dataSource = this.searchPanel.dataSource;
        }
        child._designer = this.searchPanel._designer;
    }
}
